export const routePaths = {
  ROOT: '/',
  INDEXHTML: '/index.html',
  LOGIN: '/login',
  LOGOUT: '/logout',
  CHANGEPASSWORD: '/change-password',
  ACADEMY: '/academy',
  MD: {
    ROOT: '/md',
    GUIDE: '/md/guide',
    PROFILES: '/md/profiles',
    UNITS: '/md/units',
    ANALYTICS: '/md/analytics',
    CONTACTS: '/md/contacts',
    CHANGE_REQUESTS: '/md/change-requests',
    CARDS: {
      ROOT: '/md/cards',
      PAPER_CARDS: {
        APPROVAL: '/md/cards/paper/approval',
        ORDER: '/md/cards/paper/order',
      },
    },
    LINKCODE: '/md/linkcode/:code',
    LINKCODE_SUCCESS: '/md/linkcode/success',
    LINKCODE_ERROR: '/md/linkcode/error',
    INTEGRATIONS: '/md/integrations',
    CUSTOMISESETTINGS: {
      ROOT: '/md/settings',
      PROFILE_DESIGN: '/md/settings/profile-design',
      EDIT_RIGHTS: '/md/settings/edit-rights',
      SHARING_DESIGN: '/md/settings/sharing-design',
      COMPANY_DATA: '/md/settings/company-data',
      TRANSLATIONS: '/md/settings/translations',
      CONTACT_FORM: '/md/settings/contact-form',
      EMAIL_TEMPLATES: '/md/settings/email-templates',
      EMAIL_TEMPLATES_SETTINGS: '/md/settings/email-templates/settings',
      EMAIL_SIGNATURE: '/md/settings/email-signature',
      EMAIL_SIGNATURE_SETUP: '/md/settings/email-signature/setup',
      EMAIL_SIGNATURE_BRANDING: '/md/settings/email-signature/branding',
      EMAIL_SIGNATURE_EDIT: '/md/settings/email-signature/edit',
      EMAIL_SIGNATURE_MANAGEMENT: '/md/settings/email-signature/management',
      EMAIL_SIGNATURE_EDIT_SPECIFIC: '/md/settings/email-signature/management/:id/edit',
      UNITS: '/md/settings/units',
      EXPORT: '/md/settings/export',
      CRM_INTEGRATION: '/md/settings/crm-integration',
      BILLING: '/md/settings/billing',
    },
    MOBILE: {
      MD2PHONE: '/md/mobile/md2phone',
    },
    DOMAINS: '/md/domains',
  },
  HOME: '/home',
  EDITPROFILE: '/edit-profile',
  EDITPROFILEWITHSETTINGS: '/edit-profile/:showHowToTap',
  EDITBIO: '/edit-bio',
  SHOWPROFILE: '/:username',
  ONBOARDING: '/onboarding',
  ADMIN_ONBOARDING: '/admin-onboarding',
  ADMIN_INTRO: '/admin-intro',
  QR_CODE_BACKGROUND: {
    ROOT: '/qr-code-background',
    PHONE: '/qr-code-background/phone',
    VIDEOCALL: '/qr-code-background/videocall',
  },
  SHARE_LINK: '/share-link',
  ANALYTICS: '/analytics',
  NFC_CARDS: '/nfc-cards',
  UPGRADE_TEAMS: '/upgrade-teams',
  UPGRADE_LEADGEN: '/upgrade-leadgen',
  REFERRALS: '/referrals',
  PAPER_CARDS: '/paper-business-cards',
  ACTIVATION: {
    ACTIVATION: '/activation',
    CHANGEPASSWORD: '/activation/change-password',
    EMAILVALIDATION: '/activation/email-validation',
    VERIFYEMAIL: '/activation/verify-email',
  },
  SETTINGS: {
    MAIN: '/settings',
    MORE: '/more',
    AUTH: '/settings/auth',
  },
  LANDING: {
    CHECK: '/landing/check/:usernameorcode',
    LOGIN_REGISTER: '/landing/login-or-register',
  },
  REGISTRATION: {
    REGISTER: '/registration/register',
    SIGNUP: '/registration/signup',
  },
  BUSINESS: {
    ONBOARDING: '/business/onboarding/:token',
  },
  CONTACTS: {
    ROOT: '/contacts',
    ADD: '/contacts/add',
    EDIT: '/contacts/:leadId/edit',
    SCANNER: '/contacts/scanner',
  },
  SHARE_PROFILE: '/share-profile',
  UTIL_ROUTES: {
    FLAG: '/util-lt/config/flag',
    UNFLAG: '/util-lt/config/unflag',
  },
  IDP: {
    LIST: '/md/settings/idps',
    THEME_IDPS: '/md/settings/idps/themeIdps',
    THEME_IDP_SETTINGS: '/md/settings/idps/themeIdps/:id',
    THEME_SSO_SETTINGS: '/md/settings/idps/themeIdps/:id/sso',
    THEME_SCIM_ATTRIBUTE_MAPPING: '/md/settings/idps/themeIdps/:id/scim-attribute-mapping',
  },
  CRM_CALLBACK: '/crm/callback',
  SSO_RECOVERY: '/sso-recovery',
};

export const homepageLink = 'https://lemontaps.de';

export const helpLink = 'https://wa.me/4917668086624';

export const cardsShopLinkDe = 'https://lemontaps.de/collections/alle-nfc-visitenkarten';
export const cardsShopLinkEn = 'https://lemontaps.de/en/collections/all-nfc-business-cards';

export const bookCall = 'https://zcal.co/michellebaetge/10min';

export const requestMdDe = 'https://lemontaps.de/pages/digitale-visitenkarte-fur-unternehmen';
export const requestMdEn = 'https://lemontaps.de/en/pages/digital-business-cards-for-companys';

export const rebuyCardsDe =
  'https://docs.google.com/forms/d/e/1FAIpQLSdWG3vCx6Q6MgOHLf93qRo2PoknfGfuhSQ7Kkz_EKBkd0HSSQ/viewform';
export const rebuyCardsEn =
  'https://docs.google.com/forms/d/e/1FAIpQLSfLDjiIMA7r8JsDsQYFS6RCpVckhJwnW0dLxK_NueE5m8mRtA/viewform';

export const initialBuyCardsDe =
  'https://docs.google.com/forms/d/e/1FAIpQLSd-_3HOLGhEYovvJVwaw9Fq0t_0m9-Z2BCyaBSoajvtwd6h6g/viewform?usp=sf_link';
export const initialBuyCardsEn =
  'https://docs.google.com/forms/d/e/1FAIpQLSeUdELUzPIOSe1XBdP_YOObNv1h_NRHlgwS1FnbVYyTAg_1WQ/viewform?usp=sf_link';

export const buySampleCardsDe = 'https://lemontaps.de/collections/hidden-products';
export const buySampleCardsEn = 'https://lemontaps.de/en/collections/hidden-products';

export const requestOfferLinkDe = 'https://lemontaps.de/pages/angebot-anfragen';
export const requestOfferLinkEn = 'https://lemontaps.de/en/pages/request-offer';

export const contactSalesLinkDe = 'https://lemontaps.de/pages/vertrieb-kontaktieren';
export const contactSalesLinkEn = 'https://lemontaps.de/en/pages/vertrieb-kontaktieren';

export const upgradeLink = 'https://lemontaps.de/pages/upgrade';

export const FRESHWORKS = {
  de: {
    contactFormUrl:
      'https://lemontaps.myfreshworks.com/crm/sales/web_forms/c7571b479804f2a461652bd847e11e8fd3c43aa4d9b0b455e7cb0acfaacd0acb/form.js',
    contactFormId: 'fs_c7571b479804f2a461652bd847e11e8fd3c43aa4d9b0b455e7cb0acfaacd0acb',
  },
  en: {
    contactFormUrl:
      'https://lemontaps.myfreshworks.com/crm/sales/web_forms/3d7c1f6e9737e8628773c65a615af66f11e377326550b1473ec38fbcd6e73fc1/form.js',
    contactFormId: 'fs_3d7c1f6e9737e8628773c65a615af66f11e377326550b1473ec38fbcd6e73fc1',
  },
};

export const VIDEOS = {
  LEADS: {
    DE: {
      src: 'https://www.youtube.com/embed/kvMXmOdEtTs',
      title: 'Das Lemontaps Lead Gen Feature - Erfasse effizient Deine Leads!',
    },
    EN: {
      src: 'https://www.youtube.com/embed/8mkLpWK4A60',
      title: 'The Lemontaps Lead Gen Feature - Capture your leads efficiently!',
    },
  },
  MD: {
    DE: {
      src: 'https://vimeo.com/1015588703/b22d62e8b4',
      title: 'Lemontaps Firmenlösung Demo - Werde jetzt ein digitaler Vorreiter!',
    },
    EN: {
      src: 'https://vimeo.com/1015620667',
      title: 'Lemontaps Company Solution Demo - Become a digital pioneer now!',
    },
  },
};

export const PERMISSIONS = {
  READ: {
    THEME_PROFILES: 'read:theme-profiles',
    THEME_PROFILES_AUTH_DATA: 'read:theme-profiles-auth-data',
    CHECK_CODES: 'read:check-codes',
    THEME_GLOBAL: 'read:theme-global',
    THEME_UNIT: 'read:theme-unit',
    SCIM: 'read:scim',
    IAM: 'read:iam',
  },
  WRITE: {
    THEME_PROFILES: 'write:theme-profiles',
    THEME_PROFILES_AUTH_DATA: 'write:theme-profiles-auth-data',
    THEME_GLOBAL: 'write:theme-global',
    THEME_UNIT: 'write:theme-unit',
    IAM: 'write:iam',
  },
  CREATE: {
    THEME_PROFILE: 'create:theme-profile',
    THEME_UNIT: 'create:theme-unit',
    SCIM: 'create:scim',
  },
  DELETE: {
    THEME_PROFILES: 'delete:theme-profile',
    THEME_UNIT: 'delete:theme-unit',
  },
};

export const LOCAL_STORAGE = {
  ltNoTrack: 'ltNoTrack', // 'true' | 'false'
  lt2lt: 'lt2lt', // 'true' | 'false'
  ltProfilesTableSort: 'ltProfilesTableSort', // Array<typeof COLUMNS_DEFAULT[number]['key']>
  ltContactsTableColumns: 'ltContactsTableColumns', // Array<typeof COLUMNS_DEFAULT[number]['key']>
  ltMdContactsTableColumns: 'ltMdContactsTableColumns', // Array<typeof COLUMNS_DEFAULT[number]['key']>
  ltMdUnitsTableColumns: 'ltMdUnitsTableColumns', // Array<typeof COLUMNS_DEFAULT[number]['key']>
} as const;

export const AVAILABLE_PERMISSION_LEVELS = (isUnitsEnabled: boolean) => [
  {
    name: 'plain',
    niceName: 'Employee',
    exclusiveGroups: [0],
    requiredGroups: [0],
    translateKey: 'employeeType.employee',
  },
  {
    name: 'theme_admin',
    niceName: 'Administrator',
    exclusiveGroups: [0],
    requiredGroups: [0],
    translateKey: 'employeeType.themeAdmin',
  },
  ...(isUnitsEnabled
    ? [
        {
          name: 'unit_admin',
          niceName: 'Unit-Admin',
          exclusiveGroups: [0],
          requiredGroups: [0],
          translateKey: 'employeeType.unitAdmin',
        },
      ]
    : []),
];

export const CONTROL_STATES = [
  { name: 'manual', niceName: 'Manual', translateKey: 'control.manual' },
  { name: 'scim', niceName: 'SCIM', translateKey: 'control.scim' },
  { name: 'entraIdSync', niceName: 'Entra-ID-Sync', translateKey: 'control.entraIdSync' },
];

export const EMPLOYEE_STATUS = [
  { name: 'active', niceName: 'Active', translateKey: 'statusActive' },
  { name: 'invited', niceName: 'Invited', translateKey: 'statusInvited' },
  { name: 'uninvited', niceName: 'Uninvited', translateKey: 'statusUninvited' },
];

export const CSS_VARS = {
  LT_PRIMARY_BUTTON_COLOR_VAR: 'var(--lt-primary-button-color)',
  LT_PRIMARY_BUTTON_COLOR_NAME: '--lt-primary-button-color',
  LT_PRIMARY_BUTTON_COLOR_INVERTED_NAME: '--lt-primary-button-color-inverted',
  LT_PRIMARY_BUTTON_COLOR_INVERTED_VAR: 'var(--lt-primary-button-color-inverted)',
  LT_DEFAULT_COLOR_VAR: 'var(--lt-default-color)',
  LT_DEFAULT_COLOR_NAME: '--lt-default-color',
  LT_DEFAULT_COLOR_INVERTED_NAME: '--lt-default-color-inverted',
  LT_DEFAULT_COLOR_INVERTED_VAR: 'var(--lt-default-color-inverted)',

  LT_BOTTOM_NAVBAR_HEIGHT_NAME: '--lt-bottom-navbar-height',
  LT_BOTTOM_NAVBAR_HEIGHT_VAR: 'var(--lt-bottom-navbar-height)',

  LT_MOBILE_HEADER_HEIGHT_NAME: '--lt-mobile-header-height',
  LT_MOBILE_HEADER_HEIGHT_VAR: 'var(--lt-mobile-header-height)',

  LT_DESKTOP_HEADER_HEIGHT_NAME: '--lt-desktop-header-height',
  LT_DESKTOP_HEADER_HEIGHT_VAR: 'var(--lt-desktop-header-height)',

  LT_SIDEBAR_WIDTH_NAME: '--lt-sidebar-width',
  LT_SIDEBAR_WIDTH_VAR: 'var(--lt-sidebar-width)',

  LT_SIDEBAR_WIDTH_TOGGLED_NAME: '--lt-sidebar-width-toggled',
  LT_SIDEBAR_WIDTH_TOGGLED_VAR: 'var(--lt-sidebar-width-toggled)',
} as const;

export const DEFAULT_COLOR = '#02e0b1' as const;
